import { Box } from '@ff-it/ui';
import { PositionBreakdown } from './types';
import { ReactElement } from 'react';
import { MoneyCell } from 'components/MoneyCell';

export function Breakdown({ net, budgeted }: PositionBreakdown): ReactElement {
  return (
    <Box textAlign="end" textSize="xs" lineHeight="1" minWidth="0">
      <MoneyCell value={net} />
      {budgeted !== net && <MoneyCell color="disabled" value={budgeted} />}
    </Box>
  );
}
